<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>

        <div class="language-select-con" v-if="currItem.questions[0].screen_text_trans">
          <!-- <p class="title">{{ $t('edit_message_language') }}</p> -->
          <el-select
            v-model="translationLanguage"
            size="small"
            @change="changeLanguage"
            class="language-select"
          >
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="panel-content">
        <div class="panel-content-play-con">
          <ButtonTool
            :type="'play'"
            @click.native="clickPlayTopVoice(true)"
            v-show="topPlayStatus == 'play'"
          ></ButtonTool>
          <ButtonTool
            v-show="topPlayStatus == 'pause'"
            @click.native="clickPauseTopVoice()"
            type="pause"
            slot="content"
          ></ButtonTool>
        </div>
        <div v-for="(item, key) in newQuestionList" :key="item.index + key" class="question-item">
          <div class="question-stem">
            <div class="question-index">
              {{ item?.is_example ? $('hsk_example') : item?.index }}
            </div>

            <div class="stem-content">
              <img
                v-show="item?.playStatus == 'play' || !item?.playStatus"
                @click="clickPlayVoice(item, true)"
                :src="iconPlay('play')"
                alt=""
              />
              <img
                v-if="item?.playStatus == 'pause'"
                @click="clickPauseVoice(item)"
                :src="iconPlay('pause')"
                alt=""
              />
            </div>
          </div>
          <!-- 翻译的题干 -->
          <div class="translation-question-stem" v-html="translationStemList[key]"></div>
          <div class="answer_result">
            <div class="answer_result-title">{{ $t('mark_answer') }}:</div>
            <div v-if="item.useAnswer">
              <RecordPlayer
                v-if="item.useAnswer"
                :soundUrl="item.useAnswer"
                :simpleType="false"
                :fatherPause="item.fatherPause"
                :index="key"
                @clickRecordPlayer="clickRecordPlayer"
              ></RecordPlayer>
            </div>
            <strong v-else>{{ $t('hsk_homework_no_answer') }}</strong>
            <div class="reference_answer" v-if="item?.evaluate?.standard_answer">
              <div>{{ $t('hsk_reference_answer') }}</div>
              <p
                style="fontweight: 500"
                v-for="(txt, key) in item.evaluate.standard_answer"
                :key="item.index + key"
              >
                {{ txt }}
              </p>
            </div>
            <AiSuggestScore :score="item.aiScores" />
            <div class="score-option">
              <div>{{ $t('evaluate_common_total_score') }}：</div>
              <div>
                <el-select
                  v-model="item.markScore"
                  placeholder=""
                  size="mini"
                  :disabled="$route.query.optionStatus != 1"
                >
                  <el-option
                    v-for="scoreIndex in item.score + 1"
                    :key="scoreIndex"
                    :label="scoreIndex - 1"
                    :value="scoreIndex - 1"
                  >
                  </el-option>
                </el-select>
                / {{ item.score }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
import RecordPlayer from './common/recordPlayer'
import { getLanguageSelectList, getScreenTextByLanguage } from '@/utils/hskTool'
export default {
  name: 'CommonSpeakingKtResult',
  components: {
    RecordPlayer,
  },
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      fatherPause: false,
      topPlayStatus: 'play',
      icons: {
        play: require('@/assets/images/btn_play_hsk.png'),
        pause: require('@/assets/images/btn_pause_hsk.png'),
        playHsk: require('@/assets/images/play_hsk.png'),
      },
      newQuestionList: [],
      translationLanguage: '',
      languageList: [],
      translationStemList: '',
    }
  },
  watch: {
    currItem: {
      handler(val) {
        this.newQuestionList = val.questions.map((item, index) => {
          item.fatherPause = false
          item.analysisText = item.analysis[this.language]
            ? item.analysis[this.language]
            : item.analysis['cn']
          if (val.answer && val.answer.length > 0 && !this.changeBtn) {
            item.answer = val.answer[index]
            item.recordDuration = Number(item.seconds_limt)
          }
          return item
        })
        if (val.questions[0].screen_text_trans) {
          // 如果是翻译，需要初始化多语言列表，展示对应的多语言题干
          this.languageList = getLanguageSelectList(val.questions[0].screen_text_trans)
          this.translationLanguage =
            sessionStorage.getItem('translationLanguage') || this.languageList[0].value
          this.translationStemList = []
          this.currItem.questions.forEach((ques) => {
            let tempStem = getScreenTextByLanguage(ques.screen_text_trans, this.translationLanguage)

            this.translationStemList.push(tempStem)
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    changeLanguage() {
      this.translationStemList = []
      this.currItem.questions.forEach((ques) => {
        let tempStem = getScreenTextByLanguage(ques.screen_text_trans, this.translationLanguage)
        this.translationStemList.push(tempStem)
      })
      sessionStorage.setItem('translationLanguage', this.translationLanguage)
    },
    iconPlay(playType) {
      return this.icons[playType]
    },
    clickRecordPlayer(index) {
      // this.currItem.questions.forEach((question) => {

      // })
      this.topPlayStatus = 'play'
      this.newQuestionList.forEach((val, key) => {
        val.playStatus = 'play'
        if (index != key) {
          val.fatherPause = !val.fatherPause
        }
      })
    },
    //点击播放小题题干
    clickPlayVoice(question) {
      this.resetPlayStatus(question, 'pause')
      this.topPlayStatus = 'play'

      let audioPath = this.baseUrl + question.listen.audio_file
      console.log(audioPath, 'audioPath')
      this.$player.play(audioPath)
      this.$player.onended = () => {
        this.resetPlayStatus(question, 'play')
      }
    },
    //点击暂停
    clickPauseVoice(question) {
      this.$player.pause()
      this.resetPlayStatus(question, 'play')
    },
    //点击播放顶部录音
    clickPlayTopVoice(status, isTryAgain) {
      this.newQuestionList.forEach((question) => {
        question.playStatus = 'play'
      })
      this.topPlayStatus = 'pause'
      let audioPath = this.baseUrl + this.currItem.listen.audio_file
      console.log('题干播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.topPlayStatus = 'play'
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayTopVoice(false, true)
              layer.close(index)
            },
            btn2: (index) => {
              layer.close(index)
            },
          })
        } else {
          console.log('onend触发，要emit handleRecordTypeListenEnd')
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
      localStorage.setItem('bigIndex', this.currItem.bigIndex)
    },
    //重置播放状态
    resetPlayStatus(question, status) {
      let questions = this.newQuestionList.map((item) => {
        if (item.index === question.index) {
          item.playStatus = status
          console.log(item.playStatus)
          return item
        } else {
          item.playStatus = 'play'
          return {
            ...item,
          }
        }
      })
      this.newQuestionList = questions
      console.log(questions)
    },
    clickPauseTopVoice() {
      this.topPlayStatus = 'play'
      this.$player.pause()
    },
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    wordLength() {
      return getAllWordsLength(this.inputTitle) + getAllWordsLength(this.inputText)
    },
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },
  },
  component: {
    RecordPlayer,
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-top: 10px;
  .language-select-con {
    position: absolute;
    top: 6px;
    right: 0px;
    width: 100px;
  }
}
.question-item {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #eee;
  position: relative;
}
.question-stem {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  .question-index {
    color: #b5b5be;
    margin-right: 8px;
  }
}
.score-option {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  .el-select--mini {
    width: 60px;
    ::v-deep .el-input__inner {
      height: 24px !important;
      padding: 0 0 0 10px;
    }
    ::v-deep .el-input__icon {
      line-height: 25px;
    }
  }
}
.stem-content {
  img {
    cursor: pointer;
  }
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  .answer_result {
    &-title {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      text-indent: 2em;
      line-height: 25px;
    }
    strong {
      font-weight: 600;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
      font-weight: 500;
    }
  }
}
</style>
